import * as React from 'react';
import { Link } from 'react-router-dom';
import './../../styles/Dashboard.css';

function NewPreset() {
    return(
        <Link to="/" className="action-btn">
            <span className="icon">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 0.53125C7.5 0.239062 7.25893 0 6.96429 0C6.66964 0 6.42857 0.239062 6.42857 0.53125V6.375H0.535714C0.241071 6.375 0 6.61406 0 6.90625C0 7.19844 0.241071 7.4375 0.535714 7.4375H6.42857V13.2812C6.42857 13.5734 6.66964 13.8125 6.96429 13.8125C7.25893 13.8125 7.5 13.5734 7.5 13.2812V7.4375H13.3929C13.6875 7.4375 13.9286 7.19844 13.9286 6.90625C13.9286 6.61406 13.6875 6.375 13.3929 6.375H7.5V0.53125Z" fill="white"/>
                </svg>
            </span>
            <span className="title">NEW PRESET</span>
        </Link>
    );
}

export default NewPreset;